import React, { useEffect, useState } from "react";
import { DatePicker, Form, message, Modal, Tabs } from "antd";
import AddReport from "./AddReport";
import PatientService from "../../../../../Services/PatientService";
import NoDataFound from "./../../../../../Assets/Images/Svg/nodatafound.svg";
import TabPane from "antd/es/tabs/TabPane";
import LabOrderService from "../../../../../Services/LabOrderService";

const Reports = ({ selectedPatient, permissionData }) => {
  const [myReport, setMyReport] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [viewDoc, setviewDoc] = useState(false);
  const [labReports, setLabReports] = useState([]);
  const [labReportLoad, setLabReportLoad] = useState(false);
  const loggedUserObj = sessionStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

  useEffect(() => {
    fetchPatientPermission();
  }, []);

  const patientLabReports = async (permission) => {
    setLabReportLoad(true);
    let payload = {
      userId: selectedPatient?.userId,
      patientId: selectedPatient?.patientId,
      status: 1,
    };

    try {
      const response = await LabOrderService.getLabReportsData(payload);
      setLabReports(response.data);
      setLabReportLoad(false);
    } catch (e) {
      console.error(e);
      setLabReportLoad(false);
    }
  };

  const fetchPatientPermission = () => {
    if (permissionData?.reports === "Y") {
      PatientReport(permissionData?.reports);
      patientLabReports(permissionData?.reports);
    } else {
      setMyReport([]);
      setLabReports([]);
    }
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    fetchPatientPermission();
  };

  const showModal1 = () => {
    setIsModalOpen1(true);
  };
  const handleOk1 = () => {
    setIsModalOpen1(false);
  };
  const handleCancel1 = () => {
    setIsModalOpen1(false);
  };

  const handleViewDoc = (report) => {
    setSelectedDoc(report);
    setviewDoc(true);
  };

  const handleDocOk = () => {
    setviewDoc(false);
  };
  const handleDocCancel = () => {
    setviewDoc(false);
  };

  const PatientReport = (permission) => {
    let payload = {
      userId: selectedPatient?.userId,
      patientId: selectedPatient?.patientId,
      documentType: "MY REPORT",
      status: 1,
    };
    setLoading(true);

    PatientService.getMyReport(payload)
      .then((result) => {
        setMyReport(result.data);
      })
      .catch((error) => {
        console.error("Failed to fetch reports:", error);
        setMyReport([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleViewDoc2 = (report) => {
    const url = report?.resultDocumentName;

    if (!url) {
      message.error("Document not available");
      return;
    }
    if (url.startsWith("http://") || url.startsWith("https://")) {
      window.open(url, "_blank");
      return;
    } else {
      setSelectedDoc(null);
      const reportObj = {
        ...report,
        documentName: report.resultDocumentName,
      };
      setSelectedDoc(reportObj);
      setviewDoc(true);
    }
  };

  return (
    <>
      <Tabs>
        <TabPane tab="Medical Reports(self)" key={"1"}>
          <div className="p-4 border rounded shadow-md">
            <div className="my-6 flex">
              {loading ? (
                <div className="w-full flex h-screen justify-center items-center">
                  <div className="spinner"></div>
                </div>
              ) : myReport && myReport.length > 0 ? (
                <div className="w-full grid grid-cols-2 gap-2">
                  {myReport.map((report, i) => (
                    <div key={i} className="w-full">
                      <div className="border shadow-lg p-3 rounded-lg my-2 bg-white">
                        <div className="flex justify-between">
                          <div className="flex flex-col gap-1">
                            <label className="font-medium">Date</label>
                            <p className="font-normal">{report.documentDate}</p>
                          </div>
                          <div className="flex flex-col gap-1">
                            <label className="font-medium">Title</label>
                            <p className="font-normal">{report.title}</p>
                          </div>
                          <div className="flex flex-col gap-1">
                            <label className="font-medium">Document Type</label>
                            <p className="font-normal">{report.documentType}</p>
                          </div>
                        </div>
                        <div
                          className="underline cursor-pointer text-brand-primaryColor my-1 font-medium"
                          onClick={() => handleViewDoc(report)}
                        >
                          View Document
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="w-full flex  justify-center items-center">
                  <div>
                    <img
                      src={NoDataFound}
                      alt="No Data"
                      className="w-96 h-96"
                    />
                    <p className="text-center">No Reports Found</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </TabPane>
        <TabPane tab="Lab Reports" key={"2"}>
          <div className="p-4 border rounded shadow-md bg-white">
            <div className="my-6 flex">
              {loading ? (
                <div className="w-full flex h-screen justify-center items-center">
                  <div className="spinner"></div>
                </div>
              ) : labReports && labReports.length > 0 ? (
                <div className="w-full grid grid-cols-2 gap-2">
                  {labReports.map((report, i) => (
                    <div key={i} className="w-full">
                      <div className="border shadow-lg p-3 rounded-lg my-2 bg-white relative">
                        <span
                          className={`absolute top-0 right-0 rounded-bl-lg rounded-tr-lg px-2 py-1 text-xs font-semibold text-white ${loggedUser.user.account_Id === report.vendorId
                              ? "bg-brand-primaryColor"
                              : "bg-brand-primaryColor"
                            }`}
                        >
                          {loggedUser.user.account_Id === report.vendorId
                            ? "Internal"
                            : "External"}
                        </span>
                        <div className="flex justify-between mt-2">
                          <div className="flex flex-col gap-1">
                            <label className="font-medium">Date</label>
                            <p className="font-normal">
                              {report.uploadedDateTime?.split(" ")[0]}
                            </p>
                          </div>
                          <div className="flex flex-col gap-1">
                            <label className="font-medium">Title</label>
                            <p className="font-normal">{report.labTestName}</p>
                          </div>
                          <div className="flex flex-col gap-1">
                            <label className="font-medium">Document Type</label>
                            <p className="font-normal">
                              {report.resultDocumentType}
                            </p>
                          </div>
                        </div>
                        <div
                          className="underline cursor-pointer text-brand-primaryColor my-1 font-medium"
                          onClick={() => handleViewDoc2(report)}
                        >
                          View Document
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="w-full flex justify-center items-center">
                  <div>
                    <img
                      src={NoDataFound}
                      alt="No Data"
                      className="w-96 h-96"
                    />
                    <p className="text-center">No Reports Found</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </TabPane>
      </Tabs>

      <Modal
        title={<span className="font-bold">Add Report</span>}
        visible={isModalVisible}
        onOk={() => handleCloseModal()}
        centered={true}
        footer={null}
        onCancel={() => handleCloseModal()}
        okText="Submit"
        cancelText="Cancel"
        width={600}
        maskClosable={false}
      >
        <AddReport
          onClose={handleCloseModal}
          selectedPatient={selectedPatient}
        />
      </Modal>

      <Modal
        title={<span className="font-bold">Filter Reports</span>}
        className="commonModal"
        footer={false}
        open={isModalOpen1}
        onOk={showModal1}
        onCancel={handleCancel1}
      >
        <Form
          layout="vertical"
          autoComplete="off"
          className=" grid grid-cols-2 gap-5"
        >
          <Form.Item
            className="mb-0"
            label={<span className="font-medium">From Date</span>}
            name="fromDate"
          >
            <DatePicker
              placeholder="fromDate "
              className="w-full"
              format="MM/DD/YYYY"
            />
          </Form.Item>
          <Form.Item
            className="mb-0"
            label={<span className="font-medium">To Date</span>}
            name="toDate"
          >
            <DatePicker
              placeholder="toDate"
              className="w-full"
              format="MM/DD/YYYY"
            />
          </Form.Item>
        </Form>
        <div className=" flex justify-end gap-3 mt-3 ">
          <button
            onClick={handleCancel1}
            className="bg-White border-primaryColor border rounded-md text-base text-white p-2"
          >
            Cancel
          </button>
          <button
            onClick={handleOk1}
            className="bg-brand-primaryColor p-2 text-base rounded-md text-white"
          >
            Submit
          </button>
        </div>
      </Modal>

      <Modal
        title={selectedDoc?.title}
        open={viewDoc}
        footer={[]}
        onOk={handleDocOk}
        onCancel={handleDocCancel}
      >
        {selectedDoc?.documentName.endsWith(".jpg") ||
          selectedDoc?.documentName.endsWith(".jpeg") ||
          selectedDoc?.documentName.endsWith(".png") ? (
          <div className="flex justify-center items-center h-[inherit] w-[inherit]">
            <img
              src={`${process.env.REACT_APP_IMAGE_URL}${selectedDoc?.documentName}`}
              alt="report"
            />
          </div>
        ) : (
          <iframe
            src={`${process.env.REACT_APP_IMAGE_URL}${selectedDoc?.documentName}`}
            title="report"
            style={{ width: "100%", height: "500px" }} // Adjust height as needed
          />
        )}
      </Modal>
    </>
  );
};

export default Reports;
